// extracted by mini-css-extract-plugin
export default {"projectCard":"ProjectCard_projectCard__Yum4K","thumbnail":"ProjectCard_thumbnail__OJbON","description":"ProjectCard_description__v7GyY"};